import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../general.service';
@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['../travel-modal/travel-modal.component.css','./wallet.component.css'],
})
export class WalletComponent {

  // Amount: any = [];
  // amount: number | undefined;
  amount: { [key: string]: any } = {};
  datas: { [key: string]: any } = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { amount: number },
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<WalletComponent>,
    private sanitizer: DomSanitizer,
    private tstr: ToastrService,
    private fb: FormBuilder,
    private service: GeneralService
  ) {}
  url = '';
  amountForm = this.fb.group({
    amount: [
      '',
      Validators.compose([
        Validators.required,
        Validators.minLength(3),
        Validators.pattern('^[0-9]*$'),
      ]),
    ],
    gateway:['']
  });

  close() {
    this.dialogRef.close()
  }

  proceed() {
    this.select = true;
    
  }
  fundWallet(pytChnl:string){
    this.service.loader = true;
    this.amountForm.value['gateway'] = pytChnl
    console.log(this.amountForm.value)
    this.service.fundWallet(this.amountForm.value).subscribe((data) => {
      this.service.loader = false;
      if(pytChnl== 'flutterwave'){
        this.url = data.payment_url.link
      }else{
        this.url = data.payment_url.authorization_url
      }
      this.datas = data;
      this.goToLink(this.url)
    });

  }
  goToLink(data: string) {
    window.open(data, '_self'); 
} 
  

  select = false;
  cleanURl(walletURL: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(walletURL);
  }
}
